module.exports = __webpack_public_path__ + "img/background031.5bd9d285.jpg";